const e=(e,n)=>e.filter(((e,t,d)=>d.findIndex((t=>n(e,t)))===t));export{e as deduplicateByPredicate};
